module.exports = __webpack_public_path__ + "img/HeadBar.0f1edf5c.svg";